// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-page-js": () => import("/opt/buildhome/repo/src/templates/page.js" /* webpackChunkName: "component---src-templates-page-js" */),
  "component---src-templates-home-js": () => import("/opt/buildhome/repo/src/templates/home.js" /* webpackChunkName: "component---src-templates-home-js" */),
  "component---src-templates-showcase-js": () => import("/opt/buildhome/repo/src/templates/showcase.js" /* webpackChunkName: "component---src-templates-showcase-js" */),
  "component---src-templates-post-js": () => import("/opt/buildhome/repo/src/templates/post.js" /* webpackChunkName: "component---src-templates-post-js" */),
  "component---src-templates-blog-js": () => import("/opt/buildhome/repo/src/templates/blog.js" /* webpackChunkName: "component---src-templates-blog-js" */),
  "component---src-templates-docs-js": () => import("/opt/buildhome/repo/src/templates/docs.js" /* webpackChunkName: "component---src-templates-docs-js" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/opt/buildhome/repo/.cache/data.json")

